<template>
  <vue-markdown class="p-markdownPreview" :source="source" />
</template>

<script>
import VueMarkdown from 'vue-markdown'

export default {
  components: {
    VueMarkdown
  },
  props: {
    source: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped></style>
